export class Account {
  accountId
  applicationId
  withPEO
  remainingERCCredits
  name
  accessToken
  company
  email
  phone

  constructor(account = {}) {
    this.accountId = account.accountId ? String(account.accountId) : ''
    this.applicationId = account.applicationId ? String(account.applicationId) : ''
    this.withPEO = account.withPEO ? String(account.withPEO) : ''
    this.remainingERCCredits = account.remainingERCCredits ? Number(account.remainingERCCredits) : 0
    this.name = account.name ? String(account.name) : ''
    this.accessToken = account.accessToken ? String(account.accessToken) : ''
    this.company = account.company ? String(account.company) : ''
    this.email = account.email ? String(account.email) : ''
    this.phone = account.phone ? String(account.phone) : ''
  }

  setAccount(account = {}) {
    this.accountId = account.accountId ? String(account.accountId) : ''
    this.applicationId = account.applicationId ? String(account.applicationId) : ''
    this.withPEO = account.withPEO ? String(account.withPEO) : ''
    this.remainingERCCredits = account.remainingERCCredits ? Number(account.remainingERCCredits) : 0
    this.name = account.name ? String(account.name) : ''
    this.accessToken = account.accessToken ? String(account.accessToken) : ''
    this.company = account.company ? String(account.company) : ''
    this.email = account.email ? String(account.email) : ''
    this.phone = account.phone ? String(account.phone) : ''
  }
}

export const account = new Account()